import React, { useEffect } from "react";
import { Link , useNavigate } from "react-router-dom";
import { dataClubCard } from "../../../data/data";
import { useStateContext } from "../../../context/contextProvider";


const Club = () => {
  const { baseUrl ,getAllClub , dataClub , dataClubLoading , dataClubErrMsg , dataClubShowErrMsg , getOneClub  } = useStateContext()
  useEffect(() => {
    window.scrollTo(0, 0);
    getAllClub()
  }, []);

  const navigate  = useNavigate();
  return ( 
    <div className="tw-mt-[150px]">
      <div className="tw-w-[80%] sm:tw-w-[95%] tw-mx-auto tw-my-4 tw-p-2">
        <span className="tw-text-second-zain tw-font-bold tw-text-xl md:tw-text-lg sm:tw-text-sm tw-py-3 tw-px-2 tw-pr-4 tw-rounded-sm tw-shadow-sm tw-border-r-2 tw-border-second-zain">
          ملتقى السجانة
        </span>

        <div className="tw-w-full tw-grid tw-grid-cols-3 lg:tw-grid-cols-2 tw-mt-12 tw-gap-3 md:tw-grid-cols-1 tw-items-center">
        {dataClubLoading ?
          dataClub.length == 0 ?    
          <div className="tw-py-6">
        <div
          className="tw-border-b tw-border-red-500 tw-w-full tw-rounded-lg tw-py-5 tw-px-6 tw-mb-4 tw-text-base tw-text-red-500"
          role="alert"
        >
          عذرا لم تتم الاضافة بعد
        </div>
        </div>
             :
        dataClub.map((item, index) => (
            <div
              key={index}
              data-aos="fade-down-left"
              data-aos-duration="900"
              className="tw-flex  tw-flex-col tw-justify-center tw-items-center tw-gap-3 tw-group con-club tw-border tw-border-gray-50 tw-rounded-xl tw-shadow-sm hover:tw-shadow-xl hover:tw-shadow-gray-200 tw-border-r tw-border-r-second-zain tw-cursor-pointer tw-overflow-hidden tw-transition-all tw-duration-500 tw-ease-linear"
              onClick={() => {
                navigate(`details/${item.club_name}`);
                sessionStorage.setItem("ClubId",item.id);
                getOneClub(item.id)
              }}
            >
              <div className="tw-w-full tw-h-[300px] lg:tw-h-[250px] tw-relative tw-overflow-hidden">
                <img src={`${baseUrl}${item.image}`} loading="lazy" className="tw-w-full tw-h-full tw-object-cover group-hover:tw-rotate-2 group-hover:tw-scale-110 tw-transition-all tw-duration-700 tw-ease-linear" />
                <div className="overImg tw-absolute tw-top-0 tw-right-0 tw-bg-transparent-black tw-w-full tw-h-full group-hover:tw-rotate-2 group-hover:tw-scale-110 tw-transition-all tw-duration-700 tw-ease-linear"></div>
              </div>
              <div className="tw-font-semibold tw-text-2xl sm:tw-text-xl tw-text-second-zain tw-mt-4 tw-p-2">
                <h2 className=" tw-whitespace-nowrap tw-overflow-hidden">{item.club_name}</h2>
              </div>
              <div dangerouslySetInnerHTML={{__html: item.body}} className="tw-text-sm tw-mb-5 tw-m-3 tw-h-[70px] tw-w-[90%] tw-text-center tw-overflow-hidden tw-mt-4 tw-text-gray-500 tw-p-2 tw-float-right"> 
              </div>
            </div>
          ))
        : 
        dataClubShowErrMsg 
        ?
        <div className="tw-py-6">
        <div
          className="tw-border-b tw-border-red-500 tw-w-full tw-rounded-lg tw-py-5 tw-px-6 tw-mb-4 tw-text-base tw-text-red-500"
          role="alert"
        >
          {dataClubErrMsg}
        </div>
        </div>
       : 
        <div
          className="tw-bg-gray-50 tw-rounded-lg tw-py-5 tw-px-6 tw-mb-4 tw-text-base tw-text-gray-500"
          role="alert">
          جاري التحميل...
        </div>
        }
         
        </div>
      </div>
    </div>
  );
};

export default Club;
